interface Config {
  dir: "rtl" | "ltr";
  lang: "en" | "fa";
  theme: "light" | "dark";
  baseApiURL: string;
}

const config: Config = {
  dir: "rtl",
  lang: "fa",
  theme: "light",
  baseApiURL: process.env.BASE_URL || process.env.NEXT_PUBLIC_BASE_URL || "",
};

export default config;
